// from general.js
/* global dcAnalytics getFaqPopup isMobileView */


$(document).ready(function () {
    $('#giftCardForm input[name=deliveryType]').bind('click', function () {
        const clickedDeliveryType = $(this).val();
        $('#giftCardImage img:visible').fadeOut('fast', function () {
            $('#giftCardImage #' + clickedDeliveryType + 'ex').fadeIn('fast');
            if (isMobileView() && clickedDeliveryType === 'mail') {
                $('.suggestion').hide();
            } else {
                $('.suggestion').show();
            }
        });
    });
    $('.js-faq-popup').on('click', function (e) {
        getFaqPopup(this, this.href);
        e.preventDefault();
    });
    $('.js-show-instructions').on('click', function () {
        showInstructions(this);
    });
    $('.js-gift-card-form').on('submit', function () {
        return validateGCForm();
    });
});

function validateGCForm() {
    let cardType = $('#giftCardForm input[name=deliveryType]:checked').val();
    if (cardType === 'printable') cardType = 'print';
    cardType = cardType.substring(0, 1).toUpperCase() + cardType.substring(1);
    dcAnalytics.trackEventGA(['Gift Options', 'Link', cardType]);
    return true;
}

function showInstructions(el) {
    if (!$(el).find('ul').is(':visible')) { $(el).find('ul').show('blind'); } else { $(el).find('ul').hide('blind'); }
}
